function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5303_102797)"
}, /*#__PURE__*/React.createElement("rect", {
  y: 0.716797,
  width: 32,
  height: 32,
  fill: "#FF651D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.90806 22.9118C8.0416 22.9118 7.29428 22.7655 6.66609 22.4731C6.03791 22.1807 5.55052 21.7583 5.20394 21.2059L6.94228 19.5488C7.16972 19.9279 7.45132 20.2257 7.78708 20.4423C8.12283 20.6481 8.50732 20.751 8.94055 20.751C9.43877 20.751 9.84492 20.6102 10.159 20.3286C10.4839 20.047 10.706 19.5975 10.8251 18.9802L11.9136 13.4565H7.91705L8.35569 11.3445H14.9516L13.4407 18.8502C13.2458 19.8466 12.9479 20.6427 12.5472 21.2384C12.1573 21.8233 11.6591 22.2511 11.0526 22.5218C10.446 22.7818 9.7312 22.9118 8.90806 22.9118ZM21.2391 22.9118C20.0803 22.9118 19.0784 22.706 18.2336 22.2944C17.3996 21.872 16.7552 21.2926 16.3003 20.5561C15.8454 19.8087 15.618 18.9477 15.618 17.9729C15.618 17.009 15.7859 16.11 16.1216 15.2761C16.4682 14.4421 16.9502 13.7218 17.5675 13.1153C18.1957 12.498 18.9376 12.016 19.7932 11.6694C20.6597 11.3228 21.6236 11.1495 22.6851 11.1495C23.7031 11.1495 24.6021 11.3228 25.3819 11.6694C26.1617 12.016 26.752 12.5142 27.1527 13.1641L25.2519 14.7237C24.9595 14.2905 24.5859 13.9601 24.131 13.7327C23.6761 13.5052 23.1345 13.3915 22.5063 13.3915C21.8673 13.3915 21.2879 13.5052 20.768 13.7327C20.2481 13.9493 19.7987 14.2634 19.4196 14.6749C19.0513 15.0757 18.7697 15.5468 18.5748 16.0884C18.3798 16.6299 18.2823 17.2039 18.2823 17.8105C18.2823 18.3845 18.4069 18.8881 18.656 19.3214C18.9051 19.7438 19.2679 20.0741 19.7445 20.3124C20.2211 20.5506 20.7951 20.6698 21.4666 20.6698C22.0515 20.6698 22.5984 20.5669 23.1075 20.3611C23.6165 20.1445 24.0768 19.8087 24.4884 19.3538L26.048 20.946C25.4523 21.6391 24.7429 22.1428 23.9198 22.4569C23.1075 22.7601 22.2139 22.9118 21.2391 22.9118Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5303_102797"
}, /*#__PURE__*/React.createElement("rect", {
  y: 0.716797,
  width: 32,
  height: 32,
  rx: 16,
  fill: "white"
})));

var SvgJcLogo = function SvgJcLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJcLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jc-logo.962001e9.svg";
export { ForwardRef as ReactComponent };